import React from 'react'

const ClassVideo = ({ VideoURL }) => {
    console.log(VideoURL);
  return (
      <div className="">
          {/* <div className="d-grid gap-2"> */}
          <iframe
              sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation"
              src={VideoURL}
              width="100%"
              height="340"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
          />
      </div>

     
  )
}

export default ClassVideo